function parse(structure: any, data: any): any {
  const _structure = typeof structure === 'function' ? structure.call(null, data) : structure;
  return Object.keys(_structure).reduce((acc, key, i, arr) => {
    let _mappingConfig = _structure[key];

    if (typeof _mappingConfig !== 'object' && typeof _mappingConfig !== 'function') {
      return { ...acc, [key]: eval(`data.${_mappingConfig}`) };
    }
    if (typeof _mappingConfig === 'function') {
      _mappingConfig = _mappingConfig(data);
    }
    const _params = {
      // 映射属性名称
      sourceKey: _mappingConfig.key,
      // 映射结构
      mapping: _mappingConfig.mapping,
      //  数据上下文
      // context: eval(`(_mappingConfig.context || data || {}).${_mappingConfig.key}`),
      // 默认值
      default: _mappingConfig.default,
      //  约束类型
      type: _mappingConfig.type || 'auto',
      // 返回数据结果函数
      transform: _mappingConfig.transform || null
    };

    if (typeof _params.transform === 'function') {
      return {
        ...acc,
        [key]: _params.transform(_params.sourceKey ? eval(`data.${_params.sourceKey}`) : data)
      };
    }

    if (!_params.mapping) {
      if (!_params.sourceKey) throw new Error('key not definition.' + JSON.stringify(structure));
      let value = eval(`data.${_params.sourceKey}`);
      if (_params.type !== 'auto' && Reflect.toString.call(value) !== `[object ${_params}]`) {
        console.warn('format not correct.');
        // value =
      }
      // todo: default value can be 'function' or 'array' type.
      return { ...acc, [key]: value || _params.default };
    }

    // todo: error duplicate definition
    let value = _params.sourceKey ? eval(`data.${_params.sourceKey}`) : data;
    // console.log(structure, 'data', data, _params.sourceKey, value)
    value = value !== undefined ? value : _params.default;

    // if (typeof _params.mapping === "function") {
    //   _params.mapping = Array.isArray(value) ? value.map(_params.mapping) : _params.mapping(value)
    // }

    return {
      ...acc,
      [key]: Array.isArray(value) ? batchParse(_params.mapping, value) : parse(_params.mapping, value)
    };
  }, {});
}
function batchParse(structure: any, data: any = []) {
  return data.map((item: any) => {
    if (typeof structure === 'function') {
      return parse(structure(item), item);
    }
    return parse(structure, item);
  });

  // return data.map(item => {
  //   return this.parse(structure, item)
  // });
}

export { parse, batchParse };
